import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import { roles } from '../../constants/roles';
import getSalesAgentById from '../SalesAgents/getSalesAgentById.api';
import getUserById from './getUserById';
import getContractStatus from './getContractStatus.api';
import _ from 'lodash';

const firebaseRef = firebase.database();

export default async function getAllPurchasers(role, callback) {
	if (role === roles.superadmin) {
		await firebaseRef
			.ref('/kavtek_purchasers/' + PROJECT_CODE.projectCode)
			.on('value', (snapshot) => {
				console.log('roles', role);
				var purchaserArr = [];
				var salesAgentsObj = snapshot?.val();

				if (salesAgentsObj) {
					var salesAgentsKeys =
						salesAgentsObj && Object?.keys(salesAgentsObj);
					salesAgentsKeys?.forEach((agentKey) => {
						var purchaser = salesAgentsObj[agentKey];
						var salesAgentName;
						var lotId;
						var cobrokerName;

						console.log('salesAgentsKeyssalesAgentsKeys', agentKey);

						getSalesAgentById(agentKey, (returned) => {
							salesAgentName = returned.fullName;
						});
						console.log('salesAgentName', salesAgentName);

						var purchaserObjkey = Object.keys(purchaser);

						for (const [i, key] of purchaserObjkey.entries()) {
							purchaser[key]['salesAgentName'] = salesAgentName;
							purchaserArr.push(purchaser[key]);
							var cobrokerUid = purchaser[key]['cobroker'];

							getContractStatus(
								{ leadId: purchaser[key]?.leadId },
								(returned) => {
									console.log(
										'getCgetContractStatusontractStatus',
										returned
									);
									firebaseRef
										.ref(
											'/kavtek_agreements/' +
												PROJECT_CODE.projectCode +
												'/' +
												key +
												'/productAvailability/lotId'
										)
										.once('value', (snapshot) => {
											lotId = snapshot?.val();
										});

									purchaser[key]['lotId'] = lotId || '';
									purchaser[key]['contractStatus'] =
										returned.name;
									// purchaser[key]['salesAgentName'] =
									// 	salesAgentName;

									console.log(
										'purchaser[key]',
										purchaser[key]
									);
									console.log('purahfiof', purchaserArr);

									// if (i === purchaserObjkey.length - 1) {
									// 	// do your thing
									// 	callback(purchaserArr);
									// }
								}
							);
						}
					});
					function hasDuplicates(a) {
						return _.uniq(a).length !== a.length;
					}
					let purchaserIdArr = _.map(purchaserArr, 'leadId');

					if (!hasDuplicates(purchaserIdArr)) {
						// while changing sales agent, for 1~2 sec, it creates duplicate (from previous agent and current agent). So on purchaser table, it shows duplicate for a sec and disappears.
						callback(purchaserArr);
					}
				} else {
					callback([]);
				}
			});
		return;
	} else if (role === roles.admin || role === roles.cobroker) {
		var currentUser = firebase.auth().currentUser.uid;

		var salesAgentRef;
		await firebaseRef
			.ref(
				'/kavtek_purchasers/' +
					PROJECT_CODE.projectCode +
					'/' +
					currentUser
			)
			.once('value', (snapshot) => {
				salesAgentRef = snapshot.val();
			});

		if (!salesAgentRef) {
			var salesAgentParentRef = firebaseRef.ref(
				'/kavtek_purchasers/' + PROJECT_CODE.projectCode
			);

			salesAgentParentRef.update({
				[currentUser]: '',
			});
		}

		await firebaseRef
			.ref(
				'/kavtek_purchasers/' +
					PROJECT_CODE.projectCode +
					'/' +
					currentUser
			)
			.on('value', (snapshot) => {
				var purchaserArr = [];
				var lotId;

				var salesAgentObj = snapshot.val();
				var purchaserKeys = salesAgentObj && Object.keys(salesAgentObj);

				purchaserKeys &&
					purchaserKeys.forEach((key) => {
						var purchaser = salesAgentObj[key];

						console.log('Purchaserr id', key);

						firebaseRef
							.ref(
								'/kavtek_agreements/' +
									PROJECT_CODE.projectCode +
									'/' +
									key +
									'/productAvailability/lotId'
							)
							.once('value', (snapshot) => {
								lotId = snapshot?.val();
							});

						purchaser['lotId'] = lotId || '';

						purchaserArr.push(purchaser);

						getContractStatus(
							{ leadId: purchaser?.leadId },
							(returned) => {
								purchaser['contractStatus'] = returned.name;
							}
						);
					});
				callback(purchaserArr);
			});
	}
}
